import { Leaderboard } from "../../components/Leaderboard/Leaderboard";

export function LeaderboardPage() {
  return <Leaderboard />;
}
